export const serviceFeesRoutes = {
  SERVICE_FEE: "serviceFee",
};
